import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
	selector: "app-staking-pre-screen",
	templateUrl: "./pre-screen.component.html",
	styleUrls: ["./pre-screen.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class StakingPreScreenComponent {
	@Input() autoStakingEnabled: boolean = false;
	@Input() earnOnStablecoinEnabled: boolean = false;
}
